import { ChangeDetectionStrategy, Component, HostBinding, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DashboardFacadeService } from '@anecdotes/data-store';

@Component({
  selector: 'app-activity-dashboard',
  templateUrl: './activity-dashboard.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ActivityDashboardComponent implements OnInit {
  @HostBinding('class')
  private readonly classes = 'h-full w-full';

  dashboardEmbedUrl$: Observable<SafeResourceUrl>;

  constructor(
    private dashboardFacade: DashboardFacadeService,
    private domSanitizer: DomSanitizer,
  ) {}

  ngOnInit(): void {
    this.dashboardEmbedUrl$ = this.dashboardFacade
      .getTrustActivityDashboardEmbedUrl()
      .pipe(map((url: string) => this.domSanitizer.bypassSecurityTrustResourceUrl(url)));
  }
}
